import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature-learn-17909-program-flex-family-resources'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
